import * as React from "react";
import { Row, Col } from "antd";
import {
  ApiEndpoints,
  GetEventMessage,
  ValidateIsUser,
} from "../../shared/Common";
import Api from "../../shared/Api";
import "./EqSchoolProductsBoard.scss";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthState } from "../../context/Context";
import {
  ProductType,
} from "../../shared/enums";
import EqCollapsePanel from "../../custom/eqCollapsePanel/EqCollapsePanel";
import EqToggle, { IEqToggle } from "../../custom/eqToggle/EqToggle";
import EqProductList from "../../custom/eqProductList/EqProductList";
import { EqProductsBoardOrderList } from "../../custom/eqProductsBoardOrderList/EqProductsBoardOrderList";
import EditorCreateProduct from "../../custom/editorCreateProduct/EditorCreateProduct";
import AnimationDiv from "../../custom/animationDiv/AnimationDiv";
import RevealList from "../../custom/RevealList/RevealList";

export interface IFilteredTrainings {
  name: any;
  type: any;
  date: any;
}

const EqSchoolProductsBoard = (props: any) => {
  const userDetails: any = useAuthState();
  const isUserValid: boolean = ValidateIsUser(userDetails);
  const location = useLocation();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [message, setMessage] = React.useState("");
  const [isError, setIsError] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [toggle, setToggle] = React.useState(false);

  const [studentsList, setStudentsList] = React.useState([]) as any;
  const [addNew, setAddNew] = React.useState(false);
  const [isEdit, setIsEdit] = React.useState(false);
  const [selectedProduct, setSelectedProduct] = React.useState() as any;
  const [schoolStudentsAndGroups, setSchoolStudentsAndGroups] = React.useState([]) as any;


  const [productsList, setProductsList] = React.useState({
    all: [],
    private: [],
    public: [],
  }) as any;
  const [productListToggle, setProductListToggle] = React.useState(
    ProductType.Public
  );
  const [productTypeOptions, setProductTypeOptions] = React.useState([]);
  const productInitial = {
    type: ProductType.Public,
    number: "",
    price: 0,
    title: "",
    productNumber: "",
    description: "",
    vat: "",
    imageUrl: "",
    // userId:0
  };
  const [productFormData, setProductFormData] = React.useState({
    ...productInitial,
  } as any);

  React.useEffect(() => {
    createProductTypeOptions();
    GetSchoolStudentsAndGroupsAsOptions();
    getProductList();

    // GetSchoolStudents();

    window.scrollTo(0, 0);
  }, []);

  // Toggle Filters
  const createProductTypeOptions = () => {
    var types = [] as any;
    for (var x in ProductType) {
      if (isNaN(Number(x)) == false) {
        types.push({ key: Number(x), value: ProductType[x] });
      }
    }
    setProductTypeOptions(types);
  };



  const GetSchoolStudentsAndGroupsAsOptions = async () => {
    try {
      const response = await Api.get(ApiEndpoints.School.GetSchoolStudentsAndGroupsAsOptions);
      if (response && response.status === 200) {
        setSchoolStudentsAndGroups(response.data);
      } else {
        setMessage(GetEventMessage(response.status));
      }
    } catch (error: any) {
      setIsError(true);
      setMessage(GetEventMessage(error.response.status));
    }
  };

  //Products
  const getProductList = () => {
    // let path=ApiEndpoints.UserProduct + `?unused=true`
    let path=ApiEndpoints.UserProduct;
    Api.get(path).then(
      (response) => {
        if (response && response.status == 200) {
          setIsError(false);
          setMessage("");

          // setProductList(response.data);
          formatProductListData(response.data);
        } else {
          setIsError(true);
          setMessage(GetEventMessage(response.status));
        }
      },
      (error) => {
        setIsError(true);
        setMessage(GetEventMessage(error.response.status));
      }
    );
  };

  const formatProductListData = (data: any) => {
    var privateList = data?.filter(
      (opt: any) => opt.type == ProductType.Private
    );
    var publicList = data?.filter((opt: any) => opt.type == ProductType.Public);

    var productList = {
      all: [...data],
      private: [...privateList],
      public: [...publicList],
    };
    setProductsList({ ...productList });
  };


  // Gets School students
  // including(key,school,student,group)

  // const GetSchoolStudents = () => {
  //   Api.get(ApiEndpoints.GetSchoolStudents).then(
  //     (response) => {

  //       if (response && response.status == 200) {
  //         setIsError(false);
  //         setMessage("");
  //         setStudentsList(response.data);
  //         // console.log("TrainerStudents:", response.data);
  //       } else {
  //         setIsError(true);
  //         setMessage(GetEventMessage(response.status));
  //       }
  //     },
  //     (error) => {
  //       setIsError(true);
  //       setMessage(GetEventMessage(error.response.status));
  //     }
  //   );
  // };



  const productListToggleProps: IEqToggle = {
    items: productTypeOptions,
    defaultSelectedValue: productListToggle,
    classNames: "eq-toggle-orange-border eq-toggle-create-event",
    changeFunc: (value: string) => {
      let type: number = +value;
      // setSelectedToggle(filter);
      setProductListToggle(type);
    },
  };
  const handleOnProductSend = (data: any) => {
    const list = [...productsList.all];
    var foundIndex = list.findIndex((x) => x.id == data[0].product.id);
    list[foundIndex].productOrders.push(data);

    formatProductListData(list);
  };
  const removeProduct = (data: any) => {
    Api.delete(ApiEndpoints.UserProduct + `/${data.id}`).then(
      (response) => {
        if (response && response.status == 200) {
          removeItem(data);
        } else {
          setIsError(true);
          // setErrorMessage(GetEventMessage(response.status));
        }
      },
      (error) => {
        setIsError(true);
        // setErrorMessage(GetEventMessage(error.response.status));
      }
    );
  };
  const removeItem = (data: any) => {
    if (productsList.all != undefined) {
      var updatedList =
        productsList.all != undefined
          ? productsList.all.filter((item: any) => item.id !== data.id)
          : new Array<any>();
      // setProductList(updatedList);
      formatProductListData(updatedList);
      // horsesList.map((item: any, index: number) => {
      //   item.display = index == 0 ? true : false;
      // });
    }
  };











  const showAddNew = () => {
    setAddNew(true);
  };
  const handleOnCreate = (data: any) => {
    const list = [...productsList.all];
    list.push(data);
    formatProductListData(list);
  };
  const cancelFunc = (e: any) => {
    setSelectedProduct();
    setAddNew(false);
  };

  const editProduct = (data: any) => {
    setSelectedProduct(data);
    setIsEdit(true);
  };
  const handleOnEdit = (data: any) => {
    const list = [...productsList.all];
    var foundIndex = list.findIndex((x) => x.id == data.id);
    list[foundIndex] = data;

    formatProductListData(list);
    setIsEdit(false);
  };
  const cancelEdit = (e: any) => {
    setProductFormData({ ...productInitial });
    setIsEdit(false);
  };

  return (
    <AnimationDiv>

      <div className={`eq-trainer-products-board`}>
        <div className="eq-container-fluid">
          <Row className="eq-tp-heading-row" align="middle" justify="start">
            <Col className="eq-tp-heading-col" flex="auto">
              <h3 className="eq-tp-heading">{t("allProducts")}</h3>
            </Col>
          </Row>

          <Row
          // gutter={gutter}
          >
            <Col className="gutter-row" span={24}>
              <div className="product-type">
                <div className="label">{t("selectProductType")}</div>
                <span className="dis">
                  {t("publicProductCreateNote")}
                </span>

                <div className="toggler">
                  <EqToggle {...productListToggleProps} />
                </div>
              </div>
            </Col>
          </Row>

          {productListToggle == ProductType.Private ? (
            <div className="eq-section">
              <Row>
                {productsList.private?.length > 0 && (
                  <RevealList>
                    <Col span={24}>
                      {/* <div className="eq-db-h2"> Private Products</div> */}
                      {/* <h3 className="section-heading">Private Products</h3> */}
                      <EqProductList
                        studentsAndGroups={schoolStudentsAndGroups}
                        studentsList={studentsList}
                        productList={productsList.private}
                        removeProduct={removeProduct}
                        editProduct={editProduct}
                        onProductSend={handleOnProductSend}
                      />
                    </Col>
                  </RevealList>
                )}
              </Row>
            </div>
          ) : (
            <div className="eq-section">
              <Row>
                {productsList.public?.length > 0 && (
                  <Col span={24}>
                    <RevealList>
                      {/* <div className="eq-db-h2"> Public Products</div> */}
                      {/* <h3 className="section-heading">Public Products</h3> */}

                      <EqProductList
                        studentsAndGroups={schoolStudentsAndGroups}
                        studentsList={studentsList}
                        productList={productsList.public}
                        removeProduct={removeProduct}
                        editProduct={editProduct}
                        onProductSend={handleOnProductSend}

                      />
                    </RevealList>
                  </Col>
                )}
              </Row>
            </div>
          )}

          <Row justify="end">
            {isEdit && (
              <EqCollapsePanel
                defaultOpen={true}
                header={t("editProduct")}
                children={
                  <EditorCreateProduct
                    isEdit={isEdit}
                    product={selectedProduct}
                    onEdit={handleOnEdit}
                    onCancel={cancelEdit}
                  />
                }
              />
            )}

            {!addNew ? (
              <Row className="add-btn-icon" onClick={showAddNew}>
                <img alt="" className="add" src="/plus-black.svg" />
              </Row>
            ) : (
              <>
                <EqCollapsePanel
                  defaultOpen={true}
                  header={t("createProduct")}
                  children={
                    <EditorCreateProduct
                      onCreate={handleOnCreate}
                      onCancel={cancelFunc}
                    />
                  }
                />
              </>
            )}
          </Row>
          <div className="product-order-details">
            <EqCollapsePanel
              defaultOpen={true}
              header={<div className="">{t("productOrderDetails")}</div>}
            >
              <EqProductsBoardOrderList products={productsList.all} />
            </EqCollapsePanel>
          </div>
        </div>
      </div>
    </AnimationDiv>

  );
};
export default EqSchoolProductsBoard;
